'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PrivacyPolicy.scss');

var PrivacyPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PrivacyPolicy, _Component);

  function PrivacyPolicy() {
    (0, _classCallCheck3.default)(this, PrivacyPolicy);
    return (0, _possibleConstructorReturn3.default)(this, (PrivacyPolicy.__proto__ || (0, _getPrototypeOf2.default)(PrivacyPolicy)).apply(this, arguments));
  }

  (0, _createClass3.default)(PrivacyPolicy, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('Privacy Policy'),
        preKey: 'privacy-policy_',
        articles: [{
          key: 'privacy_introduction',
          header: '1. ' + t('Introduction'),
          bodies: [_react2.default.createElement(
            'p',
            { className: 'bold' },
            t('By using our site, you consent to our online Privacy Policy. Your consent is further provided when you register as a user.')
          ), t('This Privacy Policy was last updated on 10 April 2018.'), t('We recognise the importance of protecting the privacy of personal data or personally identifiable information, being information which relates to an identifiable individual (“Personal Data”) about the users of and visitors to our website. We respect the rights of such users and visitors and the obligations imposed by applicable law and are committed to protecting your privacy in accordance with the Data Protection Acts of 1988 and 2003 (together with Data Protection Directive 95/46/EC and General Data Protection Regulation (“GDPR”) as implemented in UK and other applicable law, the “Data Protection Acts”) and Statutory Instrument 336 of 2011 - European Communities (Electronic Communications Networks and Services) (Privacy and Electronic Communications) Regulations 2011. The following Privacy Policy discloses what information we gather, how we use it, and how to correct or change it. We do not collect any information from anyone under 16 years of age. Use by a child of the Service 16-18 must be with parental/guardian’s consent . Our website, products and services are all directed to people who are at least 16 years old or older.'), t('We reserve the right, in our sole discretion, to modify, alter or update our Privacy Policy at any time. Such modifications, alterations, and updates shall be effective immediately upon posting. Your continued use of this website following the posting of a modified, altered, or updated Privacy Policy will mean you accept those modifications, alterations or updates.')]
        }, {
          key: 'data-controller',
          chapter: '2. ' + t('Data Protection Officer and Data Controller'),
          header: '2. ' + t('Data Controller, Data Controller’s Representative, Data Protection Officer'),
          bodies: [t('i. The Data Controller controlling the means of processing of your personal data and the purposes of such processing is:'), t('Secure Arts Limited (trading as Cright)'), t('Registered in UK with company number 04868437'), t('Registered office address: 5 Technology Park, Colindeep Lane,'), t('London, NW9 6BX.'), t('Tel: +44 208 962 3000'), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'Email: {{email}}.',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
              'security@cright.com'
            )
          }), t('ii. Where one of the Cright group companies is responsible for processing personal data outside the EU, Secure Arts Limited registered in UK is its EU representative.'), t('iii. Cright’s data protection officer can be contacted as follows:'), _react2.default.createElement(
            'a',
            { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:DPO@cright.com' },
            'DPO@cright.com'
          ), t('Tel: +44 208 962 3000 and ask for the DPO.')]
        }, {
          key: 'information-collect_',
          chapter: '3. ' + t('Purpose of the Processing and the Legal Basis for the Processing'),
          header: '3. ' + t('Purpose of the Processing and the Legal Basis for the Processing'),
          bodies: [t('We gather two types of information in the operation of this website:'), t('1. Personal Data:'), t('We collect information from you when you register on our site, place an order or fill out a form. This may be as an administrative user (any employee, agent or subcontractor of Cright’s record company customers who may use and access CRight Services to perform administrative functions) or as an end user (persons of our record company customers’ choosing throughout the World and who are authorized by our customers to access and use the Services, including radio stations, journalists, buyers, DJs, record label employees.) In most circumstances, Cright is Data Processor processing your Personal Data pursuant to a record company’s written instructions and it is the record company which is your Data Controller. In such circumstances, any queries that you may have in respect of your Personal Data may be directed in the first instance to the relevant record company.'), t('When ordering or registering on our site, through the “Contact Us” pages or any other area where you may send emails, submit your CV, request newsletters / blogs or provide feedback, you may be asked to enter your: name, e-mail address or credit card information as appropriate. This information will only be used by us in accordance with the terms herein and you will be asked clearly to tick consent to our processing of necessary categories of Personal Data, for each contractually agreed purpose we are to provide. This will enable you to participate in interactive features of the Service and notifying you about changes to the Service.  The provision of your Personal Data is voluntary. However, it is also necessary to enable us to fulfil our contractual obligations with record companies. Therefore if you do not provide us with the required Personal Data, we may not be able to provide you with the Service you requested.'), t('2. Non-Personal Data:'), t('We may collect information about your visit to and use of this site, including sales data, traffic data and related site information. This information helps us to evaluate and improve our site and may also be used for investment analysis purposes. As Non-Personal Data does not personally identify you, we may use it for any purpose.')]
        }, {
          key: 'personal_data_categories_',
          chapter: '4. ' + t('What categories of personal data we collect, how we collect and use (process) it and for what purpose(s)'),
          header: '4. ' + t('Categories of Personal Data'),
          bodies: [t('4.1 With a few exceptions, this information is limited to the kinds of information that are necessary to complete a contract with us. We may ask you for your:'), _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              t('Name')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('Email address')
            )
          ), t('4.2 What We Use Your Information For'), t('We, and the third party providers to you of User Files, collect information from you which may be used to:'), _react2.default.createElement(
            'table',
            { className: styles.privacyTable },
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { className: styles.header },
                t('Purpose')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Process and administer your Personal Information and process transactions, fulfil your requests, orders and/or to provide other information you requested. Where you have subscribed to a third party service and we are providing that service or User Files to you on behalf of that third party, we shall process Personal Data in accordance with that third party’s instructions, as controlled by them and as agreed with you. We require this Personal Data in order to be able to complete our contractual obligations to them and in turn their obligations to you')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Complete delivery of your order. We require this Personal Data in order to be able to complete our contractual obligations to you and to the record companies uploading User Files.')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Retain order details for repeat orders and/or when you open an account with us and where you request us to do so')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Personalize your experience')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Improve our website and app and make the website and app easier for you to use')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Improve customer service')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('To respond to your enquiries or comments submitted through our website')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Send periodic emails (Please see Direct Marketing below)')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Notify you about important news or blogs concerning our products, industry updates, events, promotions and competitions, reports and other information')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Match Personal Data with third party data. Also, we may keep track of what portions of the website and app users are visiting and other user statistics, and aggregate this information to help us create a better experience for users of our website. This is all done in order to describe our products and services to prospective partners, advertisers, and other third parties, and for other lawful purposes.')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('CRight may collect, use and disclose interactions by you with the uploaded content, for sharing with its record company customers')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Promote our products and services on our website, app and third party partners’ websites')
                )
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Provide you with information about products and services that you request from us or, where you have consented to be contacted, for such purposes which we feel may interest you')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('To obtain your feedback')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('To permit applications for employment with us and related activities to such applications')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                t('Create statistical reporting regarding our web activities')
              )
            ),
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('In addition, in order to carry out our lawful activities and for legitimate purposes, we may collect and process your Personal Data to:')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Allow you to use interactive features on our website or applications')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Retain a record of incoming and outgoing communications (e.g. email)')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Protect the security and integrity of the website and app')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Prevent and detect fraud or other prohibited or illegal activity')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('In response to a court order, request for cooperation from a law enforcement or other government agency')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('To establish or exercise legal rights')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('To bring or defend legal claims')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('For responsible corporate governance or as otherwise required or permitted by applicable laws and/or regulations')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('In circumstances in which we believe disclosure is appropriate in connection with fraud prevention and prevention of other illegal, or unlawful activity or any other activity which is or may be contrary to our legal and regulatory compliance obligations')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('To protect and defend the rights, property or safety of Cright and/or other companies in the Cright group, its/their investors and other clients, staff, and/or service providers.')
                )
              )
            )
          ), t('We continually strive to improve our website offerings based on the information and feedback we receive from you. Your information helps us to respond more effectively to your requests and support your needs.  Note: If at any time you would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.')]
        }, {
          key: 'your_rights_',
          chapter: '5. ' + t('Your Rights'),
          header: '5. ' + t('Your Rights in respect of your Personal Data') + ':',
          bodies: [_react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'This Privacy NoticePolicy is intended to provide you with information about what Personal Data Cright collects about you and how it is used. If you have any questions, please contact us at {{email}}.',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
              'security@cright.com'
            )
          }), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'If you wish to confirm that CRight is processing your Personal Data, or to have access to the Personal Data we may have about you, please contact us at {{email}}.',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
              'security@cright.com'
            )
          }), t('You have various rights in respect of your Personal Data which can be summarised as follows:'), _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              t('The right to be informed. Where Cright intends to collect your Personal Data, you have a right to consent or object to such collection for the intended purposes. In respect of each intended purpose you will be asked to tick box to indicate your consent to each intended purpose for processing of your Personal Data.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right of access. You may request to receive a copy of any Personal Data held by us, which personally identifies you. We may charge an administration fee to cover the cost of carrying out your request. We may ask you to verify your identity and for more information about your request.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right to rectification. We will correct or erase inaccuracies in the information we hold about you when we learn of the inaccuracy.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right to erasure. Personal Data may be erased if we do not have a legitimate reason for retaining the information.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right to restrict processing;')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right to data portability;')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('The right to object;')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('Rights in relation to automated decision making and profiling. Cright does not carry out any automated decision making.')
            )
          ), _react2.default.createElement(
            'p',
            { className: 'italic bold' },
            t('Please contact Cright in writing with any requests and provide verification that you are whom you say that you are.')
          ), _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              t('You may withdraw your consent to your Personal Data being processed at any time (the opt out button is available next to the opt in button where you provided your consent). ')
            ),
            _react2.default.createElement(
              'span',
              null,
              t('However, if you withdraw consent, we may not be able to provide you with the service you requested.')
            )
          )]
        }, {
          key: 'right_to_lodge_',
          chapter: '6. ' + t('Questions, Concerns and Complaint with a Supervisory Authority'),
          header: '6. ' + t('The Right to Lodge a Complaint with a Supervisory Authority'),
          bodies: [t('If you have a reason to complain about how your Personal Data has been controlled and processed by Cright, please in the first instance contact Cright and we shall endeavour to resolve your queries promptly. If you remain unsatisfied, you may lodge a complaint with:'), _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              t('Address: ')
            ),
            _react2.default.createElement(
              'span',
              null,
              t('Information Commissioner\'s Office')
            )
          ), t('Wycliffe House') + ',', t('Water Lane') + ',', t('Wilmslow') + ',', t('Cheshire') + ',', t('SK9 5AF'), _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              t('Phone: ')
            ),
            _react2.default.createElement(
              'span',
              null,
              '+44 303 123 1113 or 01625 545 745'
            )
          ), _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { className: 'bold' },
              t('Email: ')
            ),
            _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:casework@ico.org.uk' },
              'casework@ico.org.uk'
            )
          ), _react2.default.createElement(
            'p',
            { className: 'italic bold' },
            t('Please copy any such communication to us so that we can work to resolve any outstanding issues promptly.')
          )]
        }, {
          key: 'disclosure_of_personal_data_',
          chapter: '7. ' + t('Disclosure of Personal Data'),
          header: '7. ' + t('Disclosure of Personal Data'),
          bodies: [t('Your information, whether public or private, will not be sold, exchanged, transferred, or given to any other company for any reason whatsoever, without your consent, other than for the express purpose of delivering the product or Service requested.'), t('We may disclose your Personal Data to our trusted affiliates, business partners, agents, service providers, professional advisers, and to such other third parties as may reasonably be required in connection with the purposes referred to in this Privacy Policy, such as operating our website, conducting our business, or servicing you, so long as those parties agree to keep this information confidential. The providers of User Files contracted to us whose files you access shall have direct access to your Personal Data and the Service shall be provided to you by us on their behalf, under their control and at their instruction. We reserve the right to disclose any and all pertinent information to law enforcement or other governmental officials as we, in our sole discretion, believe necessary or appropriate. The disclosures of your Personal Data described in this Privacy Policy may, where you have consented to receipt of User Files from third party record companies contracted with us, involve the transfer, storage or processing of your Personal Data to a country outside of the European Economic Area (EEA) where the level of data protection is not as high as in the UK.  By providing us with your Personal Data you agree to such transfers of your Personal Data. We will take all steps reasonably necessary to ensure that your information is treated securely and in accordance with this Privacy Policy.'), t('We may also disclose Personal Data in special cases when we have reason to believe that disclosing this information is necessary to identify, contact or bring legal action against someone who may be violating our Terms of Service, or may be causing injury to or interference with any of our rights or property, other users, or anyone else. We may disclose or access account information when we believe in good faith that the law requires it and for administrative and other purposes that we deem necessary to maintain, service, and improve our products and services. In addition, if we or our assets are acquired, your Personal Data will likely be transferred or disclosed in connection with such acquisition.')]
        }, {
          key: 'direct_marketing_',
          chapter: '8. ' + t('Direct Marketing'),
          header: '8. ' + t('Direct Marketing'),
          bodies: [t('On occasion, we engage third parties to mail or send information to you, including items about products you may have purchased, or material from an event sponsor. We have a legitimate interest in processing of Personal Data for direct marketing purposes. We may send postal marketing about a new product; you may opt-out of this. In the context of a sale, we may have sought your consent for electronic marketing, but again you may opt out of this at any time by following the instructions in the marketing communication itself or by contacting us through this website.')]
        }, {
          key: 'retention_period_',
          chapter: '9. ' + t('Retention'),
          header: '9. ' + t('Retention Period'),
          bodies: [t('We shall retain and store your Personal Data securely and for as long as necessary in order to fulfil our and our partners’ (where applicable) contracts with you. We shall then only retain Personal Data for as long as necessary to comply with our legal obligations under relevant law. After a transaction, your Personal Data (credit cards, financial information, etc.) will be kept on file in order to enable recurring billing depending on your subscription plan and thereafter until you Unsubscribe in your Accounts settings.'), t('Where you have opened an account with us and requested that we retain your Personal Data, it shall be retained securely using appropriate technological and organisational measures whilst that account remains open, until you opt out of such storage and you request closure of the account.'), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'For more information on where and how long your Personal Data is stored, and for more information on your rights of erasure and portability, please contact {{email}}.',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: 'mailto:security@cright.com' },
              'security@cright.com'
            )
          })]
        }, {
          key: 'information-protect_',
          chapter: '10. ' + t('How We Protect Your Personal Data'),
          header: '10. ' + t('How We Protect Your Information'),
          bodies: [t('We implement a variety of security measures to maintain the safety of your Personal Data when you place an order or enter, submit, or access your Personal Data. To help protect the privacy of data and personally identifiable information you transmit through use of this site, we maintain physical, technical and administrative safeguards. We update and test our security technology on an ongoing basis. We restrict access to your Personal Data to those employees who need to know that information to provide benefits or services to you. In addition, we train our employees about the importance of confidentiality and maintaining the privacy and security of your information. We commit to taking appropriate disciplinary measures to enforce our employees privacy responsibilities.'), t('We offer the use of a secure server. All supplied sensitive/credit information is transmitted via Secure Socket Layer (SSL) technology and then encrypted into our payment gateway providers’ database only to be accessible by those authorized with special access rights to such systems, and are required to keep the information confidential.'), t('Our payment gateway provider is Level 1 PCI compliant.')]
        }, {
          key: 'use-cookies_',
          chapter: '11. ' + t('Terms of Use of this Website and Cookies'),
          header: '11. ' + t('Terms of Service and Cookies'),
          bodies: [t('11.1 Please also visit our Terms of Service section establishing the use, disclaimers, and limitations of liability governing the use of our website.'), t('11.2 Cookies are small files that a site or its service provider transfers to your computer’s hard drive through your Web browser (if you allow) that enables the sites or service providers systems to recognize your browser and capture and remember certain information. Cookies make web-surfing easier for you by saving your preferences so that we can use the saved information to facilitate your use of our website when you return to the website. The use of cookies is an industry standard, and as such, you will find that most major websites use them.'), t('We use cookies to compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.'), _react2.default.createElement(_reactI18next.Interpolate, {
            className: 'bold',
            i18nKey: 'Please see our {{cookiePolicyLink}} and {{securityPolicyLink}} For More Detail',
            cookiePolicyLink: _react2.default.createElement(
              _Link2.default,
              { to: '/info/cookie-policy' },
              t('Cookie Policy')
            ),
            securityPolicyLink: _react2.default.createElement(
              _Link2.default,
              { to: '/info/security' },
              t('Security Policy')
            )
          }), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'Please also visit our {{termsOfServiceLink}} section establishing the use, disclaimers, and limitations of liability governing the use of our website.',
            termsOfServiceLink: _react2.default.createElement(
              _Link2.default,
              { to: '/info/terms-of-service' },
              t('Terms of Service')
            )
          })]
        }, {
          key: 'policy_change_',
          chapter: '12. ' + t('Changes and Updates to this Privacy Policy'),
          header: '12. ' + t('Changes to our Privacy Policy'),
          bodies: [t('If we decide to change our Privacy Policy, we will post those changes on this page. We reserve the right to amend the Privacy Policy and Terms of Service at any time, for any reason, without notice to you, other than the posting of the amended Privacy Policy and Terms of Service at this site. We may e-mail periodic reminders of our notices and terms and conditions and will e-mail deployment partners of material changes thereto, but you should check our site frequently to see the current Privacy Policy and Terms of Service that is in effect and any changes that may have been made to it.')]
        }, {
          key: 'contacting_',
          chapter: '13. ' + t('Contacting Us'),
          header: '13. ' + t('Contacting Us'),
          bodies: [_react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'If there are any questions regarding this privacy policy you may {{contactLink}}.',
            contactLink: _react2.default.createElement(
              'a',
              { target: '_blank', href: 'mailto:info@cright.com?subject=PP%20enquiry', rel: 'noopener noreferrer' },
              t('contact us')
            )
          })]
        }, {
          key: 'access_Amend_information_',
          chapter: '14. ' + t('Access and Amend Your Personal Data'),
          header: '14. ' + t('Access and Amend Your Information'),
          bodies: [t('In accordance with the Data Protection Acts, you may request to receive a copy of any Personal Data held by us, which personally identifies you. We may occasionally charge an administration fee to cover the cost of carrying out your request. We may ask you to verify your identity and for more information about your request.'), t('We will correct or erase inaccuracies in the information we hold about you when we learn of the inaccuracy. Personal Data may be erased if we do not have a legitimate reason for retaining the information. You should include adequate information that you may have that will reasonably assist us in fulfilling your request(s). There is no charge for this service.'), t('If you no longer wish to receive marketing-related e-mails from us, you may opt-out of receiving such marketing-related e-mails.'), _react2.default.createElement(_reactI18next.Interpolate, {
            i18nKey: 'You should direct any requests relating to your Personal Data, or any other privacy questions, to {{email}} or to the address specified below:',
            email: _react2.default.createElement(
              'a',
              { target: '_blank', href: 'mailto:security@cright.com', rel: 'noopener noreferrer' },
              'security@Cright.com'
            )
          }), t('Registered office address: 5 Technology Park, Colindeep Lane,'), t('London, NW9 6BX.'), t('Attention: Data Protection Officer'), t('Once we receive your inquiry, we will comply with your request as soon as practicable and in any event within not more than 40 days of receipt of your request and verification that you are whom you say you are.')]
        }]
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
    /* eslint-enable max-len */

  }]);
  return PrivacyPolicy;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = PrivacyPolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/PrivacyPolicy/PrivacyPolicy.js
// module id = 2024
// module chunks = 1